define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RandomGenerator = void 0;
    var CHARACTER_SETS = {
        "Numbers": "0123456789",
        "Lowercase": "abcdefghijklmnopqrstuvwxyz",
        "Uppercase": "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        "Special": "!#$%&()*+,-./:;<=>?@[\\]^_`{|}~",
        "FaxSpecial": "!.",
        "Space": " ",
    };
    var RandomGenerator = /** @class */ (function () {
        function RandomGenerator() {
        }
        RandomGenerator.generate = function (options) {
            // Gather the character set
            var charsetStr = "";
            if (options.IncludeNumbers) {
                charsetStr += CHARACTER_SETS.Numbers;
            }
            if (options.IncludeLowercase) {
                charsetStr += CHARACTER_SETS.Lowercase;
            }
            if (options.IncludeUppercase) {
                charsetStr += CHARACTER_SETS.Uppercase;
            }
            if (options.IncludeSpecial) {
                charsetStr += CHARACTER_SETS.Special;
            }
            if (options.IncludeFaxSpecial) {
                charsetStr += CHARACTER_SETS.FaxSpecial;
            }
            if (options.IncludeSpace) {
                charsetStr += CHARACTER_SETS.Space;
            }
            // Convert to array and remove duplicate characters
            var charset = [];
            for (var i = 0; i < charsetStr.length; i++) {
                var c = charsetStr.charCodeAt(i);
                var s = null;
                if (c < 0xD800 || c >= 0xE000) // Regular UTF-16 character
                    s = charsetStr.charAt(i);
                else if (0xD800 <= c && c < 0xDC00) { // High surrogate
                    if (i + 1 < charsetStr.length) {
                        var d = charsetStr.charCodeAt(i + 1);
                        if (0xDC00 <= d && d < 0xE000) {
                            // Valid character in supplementary plane
                            s = charsetStr.substr(i, 2);
                            i++;
                        }
                        // Else discard unpaired surrogate
                    }
                }
                else if (0xDC00 <= d && d < 0xE000) // Low surrogate
                    i++; // Discard unpaired surrogate
                else
                    throw "Assertion error";
                if (s != null && charset.indexOf(s) == -1)
                    charset.push(s);
            }
            var password = "";
            var statistics = "";
            if (charset.length === 0)
                alert("Error: Character set is empty");
            else if (options.Type === 'Entropy' && charset.length == 1)
                alert("Error: Need at least 2 distinct characters in set");
            else {
                var length;
                if (options.Type === 'Length')
                    length = options.Length;
                else if (options.Type === 'Entropy')
                    length = Math.ceil(options.Length * Math.log(2) / Math.log(charset.length));
                else
                    throw "Assertion error";
                if (length < 0)
                    alert("Negative password length");
                else if (length > 10000)
                    alert("Password length too large");
                else {
                    for (var i = 0; i < length; i++)
                        password += charset[RandomGenerator.randomInt(charset.length)];
                    var entropy = Math.log(charset.length) * length / Math.log(2);
                    var entropystr;
                    if (entropy < 70)
                        entropystr = entropy.toFixed(2);
                    else if (entropy < 200)
                        entropystr = entropy.toFixed(1);
                    else
                        entropystr = entropy.toFixed(0);
                    statistics = "Length = " + length + " chars, Charset size = " + charset.length + " symbols, Entropy = " + entropystr + " bits";
                }
            }
            console.log('Random string statistics', statistics);
            return password;
        };
        // Returns a random integer in the range [0, n) using a variety of methods
        RandomGenerator.randomInt = function (n) {
            var x = RandomGenerator.randomIntMathRandom(n);
            x = (x + RandomGenerator.randomIntBrowserCrypto(n)) % n;
            return x;
        };
        RandomGenerator.randomIntMathRandom = function (n) {
            var x = Math.floor(Math.random() * n);
            if (x < 0 || x >= n)
                throw "Arithmetic exception";
            return x;
        };
        RandomGenerator.randomIntBrowserCrypto = function (n) {
            if (RandomGenerator.cryptoObject == null)
                return 0;
            // Generate an unbiased sample
            var x = new Uint32Array(1);
            do
                RandomGenerator.cryptoObject.getRandomValues(x);
            while (x[0] - x[0] % n > 4294967296 - n);
            return x[0] % n;
        };
        RandomGenerator.cryptoObject = window['crypto'] || window['msCrypto'];
        return RandomGenerator;
    }());
    exports.RandomGenerator = RandomGenerator;
});
//# sourceMappingURL=generator.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/generator.js
// module id = 77
// module chunks = 2